export default __webpack_public_path__ + "static/media/springonion.58a68edd.jfif";